import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Recruit from '@/components/Recruit'
import Company from '@/components/Company'
import Contact from '@/components/Contact'
import Privacy from '@/components/Privacy'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/recruit',
      name: 'recruit',
      component: Recruit
    },
    {
      path: '/company',
      name: 'company',
      component: Company
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact
    },
    {
      path: '/privacy',
      name: 'privacy',
      component: Privacy
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js